import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Images } from "../Components/Images";
import { FaCopy } from "react-icons/fa6";
import CopyToClipboard from 'react-copy-to-clipboard'
import toast from "react-hot-toast";
import QRCode from "react-qr-code";

const DepositModal = ({ show, handleShow, handleClose, userData }) => {




  console.log(userData.escrowAddress, "escrowAddressescrowAddress")



  return (
    <>
      <Modal
        centered
        size="sm"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="deposit_modal"
      >
        <Modal.Body className="cmn__modal">
          <p className="text-end m-0 modal__closer" onClick={handleClose}>
            <i class="fa-solid fa-xmark" />
          </p>
          <h5 className="title_txt mb-0">Deposit</h5>

          <div className="content_sec">
            <div className="qr_code_wraper mx-auto my-4">



              {/* <img src={Images.qrCode} className="img-fluid qrCode_src" /> */}

              <QRCode
               
                className="img-fluid qrCode_src"
                value={userData.escrowAddress}
                viewBox={`0 0 256 256`}
              />

            </div>

            <div className="d-flex flex-column w-100 dw_card p-3">
              <label className="label">Wallet Address</label>
              <div className="input-group walletcopyinput">
                <input
                  type="text"
                  placeholder="Wallet Address"
                  className="cred_input"
                  value={userData.escrowAddress}
                />
                <CopyToClipboard
                  text={userData.escrowAddress}
                  onCopy={() => { toast.success("Address copied!") }}
                >
                  <span className="input-group-text">
                    <FaCopy className="copy_icon" />
                  </span>
                </CopyToClipboard>
              </div>
            </div>
          </div>

          {/* <div className="d-flex mt-4 align-items-center justify-content-end">
            <button className="primary_grad_btn rounded-3 px-4 py-2">Submit</button>
          </div> */}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DepositModal;
